class CustomerPrefixController extends AbstractEntityEditController
	@register()
	@inject 'customerPrefix',
		'CustomerPrefixRepository'

	initialize: ->
		@mainCrud.entityType = 'general.customer.prefix'
		@mainCrud.entityTitle = 'wbo.customer.prefix.create.new'

		if @customerPrefix.id?
			@mainCrud.entityTitle = @customerPrefix.name
			@mainCrud.isNewEntity = false

	save: ->
		@CustomerPrefixRepository
			.save @customerPrefix, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave(response)
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity(@CustomerPrefixRepository, @customerPrefix)
